var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.861816,
    width: 71.0144,
    height: 71.0144,
    rx: 35.5072,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4498 33.3651C39.1198 32.7573 38.6422 32.2971 38.017 31.9845C37.4092 31.6545 36.6884 31.4895 35.8548 31.4895C34.4134 31.4895 33.2585 31.9671 32.3902 32.9223C31.5218 33.8601 31.0877 35.1191 31.0877 36.6995C31.0877 38.3841 31.5392 39.704 32.4423 40.6591C33.3627 41.5969 34.6218 42.0658 36.2195 42.0658C37.3136 42.0658 38.2341 41.788 38.9809 41.2322C39.745 40.6765 40.3007 39.8776 40.6481 38.8356H34.9952V35.5533H44.6858V39.6953C44.3558 40.8067 43.7914 41.8401 42.9926 42.7952C42.2111 43.7504 41.2125 44.5232 39.9968 45.1137C38.7811 45.7042 37.4092 45.9994 35.8809 45.9994C34.0748 45.9994 32.4596 45.6086 31.0356 44.8271C29.6289 44.0283 28.5261 42.9255 27.7272 41.5188C26.9457 40.1121 26.555 38.5057 26.555 36.6995C26.555 34.8934 26.9457 33.287 27.7272 31.8803C28.5261 30.4562 29.6289 29.3534 31.0356 28.5719C32.4423 27.773 34.0487 27.3736 35.8548 27.3736C38.043 27.3736 39.8839 27.9033 41.3775 28.9626C42.8884 30.022 43.8869 31.4895 44.3732 33.3651H39.4498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.d28b1b52d1d6bf35f8010daee7790e6b.svg";
export { ForwardRef as ReactComponent };